import {Directive, forwardRef, Optional, Inject, Self} from '@angular/core';
import {
  PromiseWrapper,
  ObservableWrapper,
  EventEmitter
} from '../../facade/async';
import {ListWrapper} from '../../facade/collection';
import {isPresent} from '../../facade/lang';
import {NgControl} from './ng_control';
import {Form} from './form_interface';
import {NgControlGroup} from './ng_control_group';
import {ControlContainer} from './control_container';
import {AbstractControl, ControlGroup, Control} from '../model';
import {setUpControl, setUpControlGroup, composeValidators, composeAsyncValidators} from './shared';
import {NG_VALIDATORS, NG_ASYNC_VALIDATORS} from '../validators';

export const formDirectiveProvider: any =
    /*@ts2dart_const*/ {provide: ControlContainer, useExisting: forwardRef(() => NgForm)};
export class NgForm extends ControlContainer implements Form {
  private _submitted: boolean = false;

  form: ControlGroup;
  ngSubmit = new EventEmitter();

  constructor( validators: any[], asyncValidators: any[]) {
    super();
    this.form = new ControlGroup({}, null, composeValidators(validators),
                                 composeAsyncValidators(asyncValidators));
  }

  get submitted(): boolean { return this._submitted; }

  get formDirective(): Form { return this; }

  get control(): ControlGroup { return this.form; }

  get path(): string[] { return []; }

  get controls(): {[key: string]: AbstractControl} { return this.form.controls; }

  addControl(dir: NgControl): void {
    PromiseWrapper.scheduleMicrotask(() => {
      var container = this._findContainer(dir.path);
      var ctrl = new Control();
      setUpControl(ctrl, dir);
      container.addControl(dir.name, ctrl);
      ctrl.updateValueAndValidity({emitEvent: false});
    });
  }

  getControl(dir: NgControl): Control { return <Control>this.form.find(dir.path); }

  removeControl(dir: NgControl): void {
    PromiseWrapper.scheduleMicrotask(() => {
      var container = this._findContainer(dir.path);
      if (isPresent(container)) {
        container.removeControl(dir.name);
        container.updateValueAndValidity({emitEvent: false});
      }
    });
  }

  addControlGroup(dir: NgControlGroup): void {
    PromiseWrapper.scheduleMicrotask(() => {
      var container = this._findContainer(dir.path);
      var group = new ControlGroup({});
      setUpControlGroup(group, dir);
      container.addControl(dir.name, group);
      group.updateValueAndValidity({emitEvent: false});
    });
  }

  removeControlGroup(dir: NgControlGroup): void {
    PromiseWrapper.scheduleMicrotask(() => {
      var container = this._findContainer(dir.path);
      if (isPresent(container)) {
        container.removeControl(dir.name);
        container.updateValueAndValidity({emitEvent: false});
      }
    });
  }

  getControlGroup(dir: NgControlGroup): ControlGroup {
    return <ControlGroup>this.form.find(dir.path);
  }

  updateModel(dir: NgControl, value: any): void {
    PromiseWrapper.scheduleMicrotask(() => {
      var ctrl = <Control>this.form.find(dir.path);
      ctrl.updateValue(value);
    });
  }

  onSubmit(): boolean {
    this._submitted = true;
    ObservableWrapper.callEmit(this.ngSubmit, null);
    return false;
  }

  /** @internal */
  _findContainer(path: string[]): ControlGroup {
    path.pop();
    return ListWrapper.isEmpty(path) ? this.form : <ControlGroup>this.form.find(path);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: 'form:not([ngNoForm]):not([ngFormModel]),ngForm,[ngForm]',
  providers: [formDirectiveProvider],
  host: {
    '(submit)': 'onSubmit()',
  },
  outputs: ['ngSubmit'],
  exportAs: 'ngForm'
}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_VALIDATORS, ] }, ]},
{type: undefined, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NG_ASYNC_VALIDATORS, ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
